module.exports = __webpack_public_path__ + "images/136_2048.jpg";